import React, { useEffect, useState } from 'react';
import Layouts from '../layouts/Layouts';
import { getAuthorizationHeader, http } from '../config/http';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { IconGraph } from '@tabler/icons-react';
import { IconCalendarTime } from '@tabler/icons-react';
import { DateRangePicker } from 'react-date-range';
import moment from 'moment';

const LabaPenjualan = () => {
    const [labaPenjualan, setLabaPenjualan] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(null);
    const awal = startDate ? moment(startDate).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY');
    const akhir = endDate ? moment(endDate).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY');
    const navigate = useNavigate();
    const [pembiayaan, setPembiayaan] = useState([]);

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function handleSelect(date) {
        setStartDate(date.selection.startDate);
        setEndDate(date.selection.endDate);
    }

    useEffect(() => {
        async function getLabaPenjualan() {
            setLoading(true);
            try {
                const query =
                    startDate === null && endDate === null
                        ? ''
                        : `?tgl_awal=${awal}&tgl_akhir=${akhir}`;

                const [resLaba, resPembiayaan] = await Promise.all([
                    http.get(`summary/card${query}`, {
                        headers: { Authorization: getAuthorizationHeader() },
                    }),
                    http.get(`/cashflow/pengeluaran_pembiayaan_pembayaran${query}`, {
                        headers: { Authorization: getAuthorizationHeader() },
                    }),
                ]);

                setLabaPenjualan(resLaba.data);
                setPembiayaan(resPembiayaan.data); // <- data dari endpoint baru
            } catch (err) {
                if (err.code === 'ERR_NETWORK') {
                    toast.warning('Periksa jaringan internet', { autoClose: 600 });
                } else if (err.response?.status === 401) {
                    navigate('/login');
                }
            } finally {
                setLoading(false);
            }
        }

        getLabaPenjualan();

    }, [navigate, awal, akhir]);
    const selectionRange = {
        startDate: startDate,
        endDate: endDate,
        key: 'selection',
    };

    let total_laba = 0;
    let total_item_penjualan = 0;
    let total_berat_penjualan = 0;
    let total_penjualan = 0

    let total_item_pembelian = 0;
    let total_berat_pembelian = 0;
    let total_pembelian = 0;


    return (
        <Layouts
            // title={'Laba Penjualan'} 
            compFilter={
                <div className="dropdown dropdown-end">
                    <div tabIndex={0} className="bg-amber-500 hover:bg-amber-600 text-white p-2.5 rounded-lg cursor-pointer transition-colors shadow-sm flex items-center gap-2">
                        <IconCalendarTime size={20} />
                        <span className="hidden sm:inline font-medium">Filter Tanggal</span>
                    </div>
                    <div tabIndex={0} className="dropdown-content z-[50] mt-2 p-2 shadow-2xl bg-white dark:bg-slate-800 border dark:border-slate-700 rounded-xl">
                        <DateRangePicker
                            ranges={[selectionRange]}
                            onChange={handleSelect}
                            rangeColors={['#f59e0b']}
                            className="dark:text-slate-800"
                        />
                    </div>
                </div>
            }>
            {loading ? (
                <div>
                    Loading....
                </div>
            ) : (
                <div className="sm:mx-8 mx-2 p-3 mt-4">
                    <div className="mb-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-3">
                            <div className="p-2 bg-amber-500/10 rounded-lg">
                                <IconGraph className="text-amber-500" size={28} />
                            </div>
                            Laba Penjualan
                        </h2>
                        <div className="px-4 py-2 bg-amber-50 dark:bg-amber-500/10 border border-amber-100 dark:border-amber-500/20 rounded-lg">
                            <span className="text-amber-800 dark:text-amber-400 font-medium text-sm">
                                Periode: <span className="font-bold">{awal}</span> - <span className="font-bold">{akhir}</span>
                            </span>
                        </div>
                    </div>

                    {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                        <div className="bg-white dark:bg-slate-900 p-6 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-md transition-shadow">
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-1">Total Laba Kotor</p>
                            <h3 className="text-xl font-bold text-slate-900 dark:text-slate-100">
                                Rp {numberWithCommas(labaPenjualan.reduce((acc, curr) => acc + parseFloat(curr.total_laba || 0), 0))}
                            </h3>
                        </div>
                        <div className="bg-white dark:bg-slate-900 p-6 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-md transition-shadow">
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-1">Total Penjualan</p>
                            <h3 className="text-xl font-bold text-emerald-600 dark:text-emerald-400">
                                Rp {numberWithCommas(labaPenjualan.reduce((acc, curr) => acc + parseFloat(curr.total_penjualan || 0), 0))}
                            </h3>
                        </div>
                        <div className="bg-white dark:bg-slate-900 p-6 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-md transition-shadow border-l-4 border-l-amber-500">
                            <p className="text-sm font-medium text-amber-600 dark:text-amber-500 uppercase tracking-wider mb-1 font-bold">Laba Bersih</p>
                            <h3 className="text-xl font-bold text-amber-600 dark:text-amber-500">
                                Rp {numberWithCommas(labaPenjualan.reduce((acc, curr) => acc + parseFloat(curr.total_laba || 0), 0) - (pembiayaan.total_pengeluaran || 0))}
                            </h3>
                        </div>
                        <div className="bg-white dark:bg-slate-900 p-6 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-md transition-shadow">
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-1">Total Pengeluaran</p>
                            <h3 className="text-2xl font-bold text-rose-600 dark:text-rose-400">
                                Rp {numberWithCommas(pembiayaan.total_pengeluaran || 0)}
                            </h3>
                        </div>
                    </div> */}

                    <div className="bg-white dark:bg-slate-900 shadow-xl overflow-hidden border border-slate-200 dark:border-slate-800">
                        <div className="overflow-x-auto">
                            <table className="min-w-full text-sm text-left whitespace-nowrap">
                                <thead className="bg-gradient-to-r from-amber-500 to-amber-600 text-white uppercase text-xs font-bold">
                                    <tr>
                                        <th className="px-6 py-4">Toko / Cabang</th>
                                        <th className="px-6 py-4">Laba (Kotor)</th>
                                        <th className="px-6 py-4">Penjualan</th>
                                        <th className="px-6 py-4 border-r border-amber-400/30">Pembelian</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                                    {labaPenjualan.map((laba, index) => {
                                        total_laba += parseFloat(laba?.total_laba);

                                        total_item_penjualan += parseInt(laba.total_item_penjualan);
                                        total_berat_penjualan += parseFloat(laba.total_berat_penjualan);
                                        total_penjualan += parseFloat(laba.total_penjualan);

                                        total_item_pembelian += parseInt(laba.total_item_pembelian);
                                        total_berat_pembelian += parseFloat(laba.total_berat_pembelian);
                                        total_pembelian += parseFloat(laba.total_pembelian);

                                        return (
                                            <tr className="hover:bg-amber-50/50 dark:hover:bg-slate-800/50 transition-colors" key={index}>
                                                <td className="px-6 py-5 font-bold text-slate-800 dark:text-slate-200 flex items-center gap-2">
                                                    <div className="w-1.5 h-1.5 bg-amber-500 rounded-full"></div>
                                                    {laba.nama_cabang}
                                                </td>
                                                <td className="px-6 py-5 font-bold text-amber-600 dark:text-amber-500">
                                                    Rp {numberWithCommas(laba?.total_laba || 0)}
                                                </td>
                                                <td className="px-6 py-5">
                                                    <div className="flex flex-col">
                                                        <span className="text-slate-900 dark:text-slate-100 font-bold">Rp {numberWithCommas(laba?.total_penjualan || 0)}</span>
                                                        <span className="text-xs text-slate-500 dark:text-slate-400 font-medium">{laba.total_item_penjualan} item | {laba.total_berat_penjualan} gr</span>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-5">
                                                    <div className="flex flex-col">
                                                        <span className="text-slate-900 dark:text-slate-100 font-bold">Rp {numberWithCommas(laba?.total_pembelian || 0)}</span>
                                                        <span className="text-xs text-slate-500 dark:text-slate-400 font-medium">{laba.total_item_pembelian} item | {laba.total_berat_pembelian} gr</span>
                                                    </div>
                                                </td>
                                            </tr>)
                                    })}
                                </tbody>
                                <tfoot className="bg-slate-50 dark:bg-slate-800/50">
                                    <tr className="border-t-2 border-slate-200 dark:border-slate-700">
                                        <td className="px-6 py-3 font-bold text-slate-600 dark:text-slate-100 uppercase tracking-tighter">Ringkasan Total</td>
                                        <td className="px-6 py-3 font-bold text-slate-900 dark:text-slate-100 text-lg">
                                            Rp {numberWithCommas(total_laba || 0)}
                                        </td>
                                        <td className="px-6 py-3">
                                            <div className="flex flex-col">
                                                <span className="text-slate-900 dark:text-slate-100 font-bold text-lg">Rp {numberWithCommas(total_penjualan || 0)}</span>
                                                <span className="text-xs text-slate-500 dark:text-slate-400 font-medium">{total_item_penjualan} item | {total_berat_penjualan.toFixed(3)} gr</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-3">
                                            <div className="flex flex-col">
                                                <span className="text-slate-900 dark:text-slate-100 font-bold text-lg">Rp {numberWithCommas(total_pembelian || 0)}</span>
                                                <span className="text-xs text-slate-500 dark:text-slate-400 font-medium">{total_item_pembelian} item | {total_berat_pembelian.toFixed(3)} gr</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="bg-rose-50/50 dark:bg-rose-500/10 border-t border-rose-100 dark:border-rose-900/30">
                                        <td className="px-6 py-3 font-bold text-rose-600 dark:text-rose-400 uppercase">Pembiayaan & Pengeluaran</td>
                                        <td className="px-6 py-3 font-bold text-rose-600 dark:text-rose-400 text-lg" colSpan={3}>
                                            - Rp {numberWithCommas(pembiayaan.total_pengeluaran || 0)}
                                        </td>
                                    </tr>
                                    <tr className="bg-emerald-50 dark:bg-emerald-500/10 border-t-2 border-emerald-500/30">
                                        <td className="px-6 py-3 font-black text-emerald-700 dark:text-emerald-400 uppercase text-lg">Laba Bersih</td>
                                        <td className="px-6 py-3 font-black text-emerald-700 dark:text-emerald-400 text-lg" colSpan={3}>
                                            Rp {numberWithCommas(total_laba - (pembiayaan.total_pengeluaran || 0))}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            )}

        </Layouts>
    );
};

export default LabaPenjualan;